var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbonHorizontalBannerDesignSvgrepoCom4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_7904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.583 73.6777V97.8408H170.085L164.4 85.0824L170.085 73.6777H156.583Z",
    fill: "#006FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.798 101.544H153.74V97.8409V73.6779V69.9746H140.798V101.544Z",
    fill: "#006FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.586 97.8408V73.6777H0.0836182L5.76828 85.4379L0.0836182 97.8408H13.586Z",
    fill: "#006FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4262 97.8409V101.544H29.3673V69.9746H16.4262V73.6779V97.8409Z",
    fill: "#006FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2109 67.1326V68.5538V69.975V101.544V102.965V104.387V107.884C32.2109 107.884 64.0502 97.6313 85.0825 97.6313C106.115 97.6313 137.954 107.884 137.954 107.884V104.387V102.965V101.544V69.975V68.5538V67.1326V63.6363C137.954 63.6363 105.942 55.656 85.0467 55.6602C64.1793 55.6643 32.2109 63.6363 32.2109 63.6363V67.1326Z",
    fill: "#006FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1828 73.7539L58.1331 77.0791L61.9203 77.8935L59.3384 80.7629L59.7288 84.5914L56.1828 83.0397L52.6368 84.5914L53.0272 80.7629L50.4453 77.8935L54.2325 77.0791L56.1828 73.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7375 70.3535L77.6878 73.6787L81.475 74.4931L78.8931 77.3625L79.2835 81.191L75.7375 79.6393L72.1915 81.191L72.5819 77.3625L70 74.4931L73.7872 73.6787L75.7375 70.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5812 70.3535L95.5315 73.6787L99.3187 74.4931L96.7369 77.3625L97.1272 81.191L93.5812 79.6393L90.0353 81.191L90.4256 77.3625L87.8438 74.4931L91.631 73.6787L93.5812 70.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.284 72.9023L114.235 76.2275L118.022 77.0419L115.44 79.9114L115.83 83.7398L112.284 82.1881L108.738 83.7398L109.129 79.9114L106.547 77.0419L110.334 76.2275L112.284 72.9023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_7904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white",
    transform: "translate(0.0820312 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonHorizontalBannerDesignSvgrepoCom4);
export default __webpack_public_path__ + "static/media/ribbon-horizontal-banner-design-svgrepo-com 4.baea6873e6ecce094e4b5f90bf883c8f.svg";
export { ForwardRef as ReactComponent };